// extracted by mini-css-extract-plugin
module.exports = {"input_container":"Input_input_container__U4M9n","text":"Input_text__kS5o7"};